(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('curves-product')) {
  customElements.define('curves-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-product-data]').textContent);
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.addButton = this.querySelector('[data-add-button]');
      this.status = this.querySelector('[data-selection-status]');
      this.price = this.querySelector('[data-product-price]');
      this.initialPrice = this.price.innerHTML;
      this.radios = [...this.querySelectorAll('[data-option-position]')];
      this.groups = [...this.querySelectorAll('[data-option-group]')];
      this.order = this.groups.map((group, index) => index);
      const colorPosition = this.groups.findIndex(group => /colou?r|لون/iu.test(group.dataset.optionName || ''));
      if (colorPosition >= 0) this.order = [colorPosition, ...this.order.filter(position => position !== colorPosition)];
      this.quantity = this.form.querySelector('input[name="quantity"]');
      this.form.addEventListener('change', event => {
        if (event.target.matches('[data-option-position]')) this.updateSelection(Number(event.target.dataset.optionPosition));
      });
      this.form.addEventListener('submit', event => {
        if (!this.selected || !this.selected.available || this.selected.price <= 0) {
          event.preventDefault();
          this.status.textContent = this.data.strings.select;
          this.radios.find(input => !input.disabled)?.focus();
          return;
        }
        if (!this.form.reportValidity()) event.preventDefault();
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-image]');
        if (thumb) {
          event.preventDefault();
          this.showImage(thumb.dataset.galleryImage, thumb.dataset.galleryAlt, thumb);
          return;
        }
        if (event.target.closest('[data-zoom-link]')) {
          const dialog = this.querySelector('[data-zoom-dialog]');
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            this.querySelector('[data-zoom-image]').src = this.querySelector('[data-main-image]').src;
            dialog.showModal();
          }
        }
        if (event.target.closest('[data-close-dialog]')) this.querySelector('[data-zoom-dialog]').close();
      });
      const dialog = this.querySelector('[data-zoom-dialog]');
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      this.updateSelection(null, false);
    }

    updateSelection(changedPosition = null, updateUrl = true) {
      const choices = this.groups.map(group => group.querySelector('input:checked')?.value ?? null);
      const purchasableVariants = this.data.variants.filter(item => item.available && item.price > 0);
      const changedRank = this.order.indexOf(changedPosition);
      if (changedRank >= 0) {
        for (const position of this.order.slice(changedRank + 1)) {
          if (choices[position] === null) continue;
          const higher = this.order.slice(0, this.order.indexOf(position));
          const compatible = purchasableVariants.some(item => item.options[position] === choices[position] && higher.every(index => choices[index] === null || item.options[index] === choices[index]));
          if (!compatible) {
            const selected = this.groups[position].querySelector('input:checked');
            if (selected) selected.checked = false;
            choices[position] = null;
          }
        }
      }
      for (const input of this.radios) {
        const position = Number(input.dataset.optionPosition);
        const higher = this.order.slice(0, this.order.indexOf(position));
        input.disabled = !purchasableVariants.some(item => item.options[position] === input.value && higher.every(index => choices[index] === null || item.options[index] === choices[index]));
      }
      const complete = this.data.defaultOnly || choices.every(value => value !== null);
      const variant = this.data.defaultOnly ? this.data.variants[0] : complete ? this.data.variants.find(item => item.options.every((value, index) => value === choices[index])) : null;
      this.selected = variant || null;
      const purchasable = Boolean(variant && variant.available && variant.price > 0);
      const hasPurchasable = purchasableVariants.length > 0;
      this.variantInput.disabled = !purchasable;
      this.variantInput.value = purchasable ? String(variant.id) : '';
      this.addButton.disabled = !purchasable;
      if (purchasable) {
        this.addButton.textContent = this.data.strings.add;
        this.status.textContent = this.data.strings.available;
      } else if (!hasPurchasable || variant) {
        const soldOut = !this.data.variants.some(item => item.available) || Boolean(variant && !variant.available);
        this.addButton.textContent = soldOut ? this.data.strings.soldOut : this.data.strings.unavailable;
        this.status.textContent = soldOut ? this.data.strings.soldOut : this.data.strings.priceUnavailable;
      } else {
        this.addButton.textContent = this.data.strings.choose;
        this.status.textContent = this.data.strings.select;
      }
      this.status.classList.toggle('error', !hasPurchasable || Boolean(variant && !purchasable));
      this.status.classList.toggle('available', purchasable);
      if (variant) {
        this.price.replaceChildren();
        if (variant.price > 0) {
          const amount = document.createElement('span');
          amount.className = 'price money';
          amount.textContent = variant.priceText;
          this.price.append(amount);
          if (variant.comparePrice > variant.price) {
            const old = document.createElement('s');
            old.className = 'money';
            old.textContent = variant.compareText;
            this.price.append(old);
          }
        } else this.price.textContent = this.data.strings.priceUnavailable;
        this.quantity.min = String(variant.min || 1);
        this.quantity.step = String(variant.step || 1);
        if (variant.max) this.quantity.max = String(variant.max);
        else this.quantity.removeAttribute('max');
        if (Number(this.quantity.value) < Number(this.quantity.min)) this.quantity.value = this.quantity.min;
        if (variant.max && Number(this.quantity.value) > variant.max) this.quantity.value = String(variant.max);
      } else this.price.innerHTML = this.initialPrice;
      if (updateUrl) {
        const url = new URL(location.href);
        if (variant) url.searchParams.set('variant', String(variant.id));
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
        const previewVariant = variant || purchasableVariants.find(item => choices.some(value => value !== null) && choices.every((value, index) => value === null || item.options[index] === value));
        if (previewVariant?.image) {
          const thumb = this.querySelector('[data-media-id="' + previewVariant.mediaId + '"]');
          this.showImage(previewVariant.image, this.querySelector('h1').textContent, thumb);
        }
      }
    }

    showImage(src, alt, thumb) {
      const image = this.querySelector('[data-main-image]');
      if (!image) return;
      image.src = src;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.alt = alt || image.alt;
      this.querySelector('[data-zoom-link]').href = src;
      for (const link of this.querySelectorAll('[data-gallery-image]')) {
        link.classList.toggle('active', link === thumb);
        if (link === thumb) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
